

















import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  props: ['propertyName'],
  data(): {
    boxplotChartOptions: ApexOptions;
    boxplotSeries: {
      name: string;
      type: string;
      data: Array<{ x: string; y: number | Array<number> }>;
    }[];
  } {
    const boxplot =
      this.$store.getters.labelAnalysisResult[this.propertyName].boxplot;

    const outliers: { x: string; y: number }[] = [];
    const boxplotOutliers: {
      name: string;
      type: string;
      data: { x: string; y: number }[];
    } = {
      name: 'outliers',
      type: 'scatter',
      data: outliers,
    };

    const xName = '';
    if (boxplot.outlier_min && boxplot.outlier_min < boxplot.min) {
      outliers.push({ x: xName, y: boxplot.outlier_min });
    }
    if (boxplot.outlier_max && boxplot.outlier_max > boxplot.max) {
      outliers.push({ x: xName, y: boxplot.outlier_max });
    }

    return {
      boxplotChartOptions: {
        chart: {
          toolbar: {
            show: true,
            tools: {
              selection: false,
              zoom: false,
              zoomout: false,
              zoomin: false,
              pan: false,
              reset: false,
            },
          },
          width: '100%',
        },
        colors: ['#5BD99C'],
        xaxis: {
          position: 'bottom',
          labels: {
            show: true,
          },
        },
        yaxis: {
          labels: {
            show: true,
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'right',
          fontSize: '12px',
          show: true,
          inverseOrder: true,
        },
        stroke: {
          show: true,
          colors: ['#323C47'],
          width: 0.5,
        },
        plotOptions: {
          boxPlot: {
            colors: {
              upper: '#5BD99C',
              lower: '#FF974D',
            },
          },
        },
      },
      boxplotSeries: [
        {
          name: 'box',
          type: 'boxPlot',
          data: [
            {
              x: ``,
              y: [
                boxplot.min,
                boxplot.lower_qt,
                boxplot.median,
                boxplot.upper_qt,
                boxplot.max,
              ],
            },
          ],
        },
        boxplotOutliers,
      ],
    };
  },
  computed: {},
});
